"use strict";

var _taggedTemplateLiteral = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject22() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  text-align: center;\n"]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  right: 0;\n  top: -2.25rem;\n  color: ", ";\n"]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  text-align: center;\n  position: relative;\n"]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n  color: var(--color-grey-dark-1);\n"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  color: ", ";\n  font-size: ", ";\n  font-weight: normal;\n"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n  padding-bottom: 0.375em;\n  border-bottom: 1px solid var(--color-grey-light-3);\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n  font-weight: bold;\n  font-size: ", ";\n  text-align: right;\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n\n  font-weight: bold;\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n\n  font-size: ", ";\n  width: min-content;\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n\n  font-weight: bold;\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  &:not(:last-child) {\n    border-bottom: 1px solid var(--color-grey-dark-3);\n  }\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  border-bottom: 1px solid var(--color-grey-dark-2);\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  font-weight: normal;\n  color: #000000;\n\n  border: 0;\n  border-spacing: 0;\n  border-collapse: collapse;\n\n  & * {\n    font-weight: inherit;\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  padding: 0.375em;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  text-align: center;\n\n  &:not(:last-child) {\n    border-right: 1px solid var(--color-grey-dark-3);\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  color: var(--color-primary);\n  padding: 0.375em;\n  text-align: center;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  padding: 0.75em;\n\n  border-radius: 0 0 10px 10px;\n\n  & > :nth-of-type(1),\n  & > :nth-of-type(2) {\n    margin-bottom: 1.125em;\n  }\n\n  background-color: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  flex: 1;\n\n  padding: 0.525rem 0.375rem;\n  margin: 0 0.25rem;\n\n  border-radius: 0.75em;\n\n  font-weight: normal;\n  color: #fff;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  background-color: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  white-space: pre-wrap;\n  font-size: ", ";\n  padding-bottom: 0.375em;\n  color: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  padding: 1.5em;\n\n  background-color: ", ";\n\n  border-radius: 10px 10px 0 0;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  max-width: ", ";\n  min-width: ", ";\n  border: 1px solid var(--color-grey-light-3);\n  box-shadow: var(--box-shadow-node);\n\n  border-radius: 10px;\n\n  /* \n   * action preview \u3092 node \u306E\u5916\u5074\u306B\u8868\u793A\u3055\u305B\u308B\u305F\u3081\u3001overflow: hidden \u3092\u4F7F\u7528\u3067\u304D\u306A\u3044\n   * \u305D\u306E\u305F\u3081\u3001\u5B50\u8981\u7D20\u5074\u3067\u3082 border-radius: 10px \u3092\u6307\u5B9A\n   */\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importStar(require("styled-components"));

var scenario_state_1 = require("../../redux/scenario/scenario.state");

var defaultDesign = scenario_state_1.INITIAL_SCENARIO_DESIGN.greetingScenarioNode;
exports.StyledGreetingNodeDiv = styled_components_1.default.div(_templateObject(), function (props) {
  return props.theme.fontSize.default + 'rem';
}, function (props) {
  return props.theme.maxWidth + 'rem';
}, function (props) {
  return props.theme.minWidth + 'rem';
});
exports.StyledGreetingNodeHeaderDiv = styled_components_1.default.div(_templateObject2(), function (props) {
  return props.backgroundColor || defaultDesign.bodyBackColor;
});
exports.StyledGreetingMessagePre = styled_components_1.default.pre(_templateObject3(), function (props) {
  return props.theme.fontSize.large + 'rem';
}, function (props) {
  return props.color || defaultDesign.bodyTextColor;
});
exports.StyledBodyButtonDiv = styled_components_1.default.div(_templateObject4(), function (props) {
  return props.backgroundColor || defaultDesign.bodyButtonColor;
});
exports.StyledBodyDiv = styled_components_1.default.div(_templateObject5(), function (props) {
  return props.backgroundColor || defaultDesign.footerBackColor;
});
exports.StyledReloadP = styled_components_1.default.p(_templateObject6());
/* tiemTable disdplay
============================*/

var thTdCommonStyle = styled_components_1.css(_templateObject7());
exports.StyledTimeTableDisplayWrapperDiv = styled_components_1.default.div(_templateObject8());
exports.StyledTimeTable = styled_components_1.default.table(_templateObject9());
exports.StyledTimeTableThead = styled_components_1.default.thead(_templateObject10());
exports.StyledTimeTableTh = styled_components_1.default.th(_templateObject11(), thTdCommonStyle);
exports.StyledTimeTableBorderBottomTr = styled_components_1.default.tr(_templateObject12());
exports.StyledDayTh = styled_components_1.default(exports.StyledTimeTableTh)(_templateObject13(), thTdCommonStyle);
exports.StyledTimeTd = styled_components_1.default.td(_templateObject14(), thTdCommonStyle, function (props) {
  return props.theme.fontSize.small + 'rem';
});
exports.StyledStatusTd = styled_components_1.default.td(_templateObject15(), thTdCommonStyle);
exports.StyledExplanationP = styled_components_1.default.p(_templateObject16(), function (props) {
  return props.theme.fontSize.medium + 'rem';
});
/* body item disdplay
============================*/

var TITLE_COLOR = '#695252'; // see functions/bot/scenarioGenerate.ts line.727

exports.StyledBodyItemWrapperDiv = styled_components_1.default.div(_templateObject17());
exports.StyledBodyItemTitleH2 = styled_components_1.default.h2(_templateObject18(), TITLE_COLOR, function (props) {
  return props.theme.fontSize.default + 'rem';
});
exports.StyledBodyItemContentDiv = styled_components_1.default.div(_templateObject19());
/* openingTime display
============================*/

var OPENING_TIME_COMMENT_COLOR = '#cdd909'; //see functins/bot/scenarioGenerate.js line.737

exports.StyledOpeningTimeP = styled_components_1.default.p(_templateObject20(), function (props) {
  return props.theme.fontSize.medium + 'rem';
});
exports.StyledOpeningTimeCommentSpan = styled_components_1.default.span(_templateObject21(), OPENING_TIME_COMMENT_COLOR);
/* waitingTime display
============================*/

exports.StyledWaitingTimeP = styled_components_1.default.p(_templateObject22(), function (props) {
  return props.theme.fontSize.large + 'rem';
});